/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MessengerIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Messenger',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2.323c-8.6 0-15.578 6.609-15.578 14.761A14.336 14.336 0 0 0 7.091 27.6v7.562l6.675-3.872a16.414 16.414 0 0 0 4.234.555c8.6 0 15.578-6.609 15.578-14.761S26.6 2.323 18 2.323Zm1.639 19.713-4.049-4.154L8.2 22l8.167-8.942 4.083 3.978 7.463-4.048Z"
    />
  </svg>`;
};
